export default "__VITE_ASSET__DNi2kz2E__"